import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface UsersResultProps {
  data?: Api.SearchResult<Api.UserSearchResult>;
  searchQuery: string;
}

const User = ({
  user,
  searchQuery,
}: {
  searchQuery: string;
  user: Api.UserSearchResult;
}) => {
  const openGroup = useCallback(() => {
    history.push(`${ROUTES.USERS}?userId=${user.userId}`);
  }, [user.userId]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Highlighter searchWords={[searchQuery]} textToHighlight={user.name} />{" "}
        [
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={user.userId}
        />
        ]
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the Users catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<Api.UserSearchResult>} data - api response
 */

const Users = ({ data, searchQuery }: UsersResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.USERS}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogUsers")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((u, index) => (
            <User key={index} searchQuery={searchQuery} user={u} />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default Users;
